import List from './List'

export default {
  List,
}